import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import groupSelectors from '../store/selectors/group.selectors'
import { groupActions } from '../store/slices/group.slice'
import { DEFAULT_COLLAPSE_THRESHOLD } from '../constants/collapse-thresholds'

/**
 * Apply default collapsed state for submissions groups on first load only.
 * - If totalSubmissionsCount >= threshold: collapse all current groups
 * - Otherwise: do nothing (expanded by default)
 * This hook runs once per mount when groups are available and does not persist across model changes.
 */
const useDefaultGroupsCollapse = (groups, totalSubmissionsCount, threshold = DEFAULT_COLLAPSE_THRESHOLD) => {
    const dispatch = useDispatch()
    const collapsedGroupIds = useSelector(groupSelectors.collapsedGroupIds)
    const initializedRef = useRef(false)

    useEffect(() => {
        if (initializedRef.current) return
        if (!Array.isArray(groups) || groups.length === 0) return

        const total = Number(totalSubmissionsCount) || 0
        if (collapsedGroupIds?.length > 0) {
            initializedRef.current = true
            return
        }

        if (total >= threshold) {
            dispatch(groupActions.setCollapsedGroupsKeys(groups.map(group => group.id)))
        }

        initializedRef.current = true
    }, [groups, totalSubmissionsCount, threshold, collapsedGroupIds?.length, dispatch])
}

export default useDefaultGroupsCollapse


